import script from "./TimeToEndSession.vue?vue&type=script&lang=ts&setup=true"
export * from "./TimeToEndSession.vue?vue&type=script&lang=ts&setup=true"

import "./TimeToEndSession.vue?vue&type=style&index=0&id=2047e963&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2047e963"]])

export default __exports__